import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSent = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1138 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M79.644 989.867l992.711-425.528c46.080-19.911 46.080-84.764 0-104.676l-992.711-425.529c-37.547-16.498-79.076 11.378-79.076 51.769l-0.569 262.258c0 28.444 21.049 52.907 49.493 56.32l803.84 107.52-803.84 106.95c-28.444 3.982-49.493 28.444-49.493 56.889l0.569 262.258c0 40.391 41.529 68.267 79.076 51.769z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSent);
export default ForwardRef;
